import { ApiChartAttribute, ApiMetric } from "@incendium/api";
import { ApiDimension } from "@incendium/api";
import { ContentExplorer } from "features/explorer";
import { ExplorerProvider } from "features/explorer";
import { TExploreConfig } from "features/explorer/types";
import { useMemo } from "react";
import { TTableCustomCellRender } from "..";

type Tab = "explore";

function TimeAndDayInsights({
  attributes,
}: {
  attributes?: ApiChartAttribute[];
}) {
  const config: TExploreConfig<Tab> = useMemo(
    () => ({
      explore: {
        title: "Time and Day Explorer",
        desc: `Explore hourly and daily patterns in sessions and conversions to drive better results.`,
        type: "top",
        ranking: [],
        ordrerByDimension: true,
        analyseBy: {
          description: "Select Hourly or Daily",
          grouping: [
            {
              option: "Granularity",
              dimensions: [
                ApiDimension.DIMENSION_SESSION_START_BY_HOUR_OF_DAY,
                ApiDimension.DIMENSION_SESSION_START_BY_WEEKDAY,
                ApiDimension.DIMENSION_SESSION_START_BY_DAY_OF_MONTH,
                ApiDimension.DIMENSION_SESSION_START_BY_DAY_OF_YEAR,
              ],
            },
          ],
        },
        attributes,
      },
    }),
    [attributes],
  );

  const tableCustomHeaderRender = useMemo<TTableCustomCellRender>(
    () => ({
      [ApiDimension.DIMENSION_SESSION_START_BY_HOUR_OF_DAY]: () => (
        <>Hour of Day</>
      ),
      [ApiDimension.DIMENSION_SESSION_START_BY_WEEKDAY]: () => <>Weekday</>,
      [ApiDimension.DIMENSION_SESSION_START_BY_DAY_OF_MONTH]: () => (
        <>Day of Month</>
      ),
      [ApiDimension.DIMENSION_SESSION_START_BY_DAY_OF_YEAR]: () => (
        <>Day of Year</>
      ),
    }),
    [],
  );

  return (
    <>
      <ExplorerProvider configs={config} type="explore">
        <ContentExplorer
          dimensionNoClick
          tableCustomHeaderRender={tableCustomHeaderRender}
          metrics={[
            ApiMetric.METRIC_SESSIONS_COUNT,
            ApiMetric.METRIC_EFFECTIVE_SESSIONS_COUNT,
            ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
            ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE_DURING_SESSION,
            ApiMetric.METRIC_AVERAGE_PAGEVIEWS_PER_SESSION,
            ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_COUNT,
            ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_RATE,
            ApiMetric.METRIC_CHECKOUT_START_COUNT,
            ApiMetric.METRIC_CHECKOUT_START_RATE,
            ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
            ApiMetric.METRIC_MACRO_CONVERSION_RATE,
            ApiMetric.METRIC_REVENUE,
          ]}
        />
      </ExplorerProvider>
    </>
  );
}

export default TimeAndDayInsights;
